<template>
  <div>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <div class="pageIndex">
        <van-icon
          name="https://op.chinabeego.com/user/img/totop.png"
          class="upgrade"
          @click="scrollTopdome"
          v-show="!show"
        />
        <Header :banners="banners" />
        <Activety :activity="activity" :branchImage="branchImage" :beess="beess" />
        <TabItem :categoreis="categoreis" :activity="activity" />
      </div>
    </van-pull-refresh>
    <!-- <div class="by-gry" v-if="newShow">
      <div class="ing">
        <div class="div0">
          <p class="div1">恭喜你获得新人礼包</p>
          <p class="div2">￥500</p>
          <p class="div3" @click="goCouponViewFun">立即领取</p>
        </div>
      </div>
      <div class="clo" @click="newShow = false;">
        <van-icon name="close" size="30" />
      </div>
    </div> -->
    <bombScreen pageCode="1"></bombScreen>
  </div>
</template>
<script>
import Header from "@/components/header/header";
import Activety from "@/components/activity/activety";
import TabItem from "@/components/commodity/commodity";
import http from "@/utils/axios";
import utils from "@/utils/common";
import bombScreen from "@/components/home/bombscreen";
export default {
  data() {
    return {
      isLoading: false,
      show: false,
      refresh: false,
      activity: {},
      banners: [],
      branchImage: {},
      categoreis: [],
      beess: [],
      newShow: false
    };
  },
  methods: {
    getDate() {
      http({
        url: "/base/user/join/index",
        method: "post"
      }).then(rps => {
        if (rps.code === 200) {
          this.$loading.hide();
          this.banners = rps.data.banners;
          this.activity = rps.data.activity;
          this.branchImage = rps.data.branchImage;
          this.categoreis = rps.data.categoreis;
          this.beess = (rps.data && rps.data.beess) || [];
        }
      });
      utils.nativeMethod({tm:'4000101',tp:{page_evar:'首页'}})
    },
    onRefresh() {
      // this.getDate();
      this.refresh = !this.refresh;
      setTimeout(() => {
        this.isLoading = false;

        window.location.reload();
      }, 1000);
    },
    scrollTopdome() {
      document.querySelector("#app").scrollTop = 0;
    },
    goCouponViewFun() {
      if (!sessionStorage.getItem("token")) {
        sessionStorage.clear();
        utils.needUserLogin();
      } else {
        this.$router.push({
          path: "/myCoupon"
        });
      }
    }
  },
  created() {
    //this.$store.commit('showLoading');
    if (this.$route.params.token) {
      sessionStorage.setItem("token", this.$route.params.token);
      //todo 是新用户且在活动优惠期内
      //this.newShow = true;
    } else {
      //this.newShow = true;
    }
    
    this.getDate();
    // 拿用户信息
    utils.nativeMethod({tm:'4000003',tp:{key:'setUserInfo'}});
    window['setUserInfo']=function(res){
      let t = res;
      if(typeof res ==='object'){
        t = JSON.stringify(t)
      }
      window.localStorage.setItem("userInfo",t);
    }
  },
  components: { Header, Activety, TabItem, bombScreen }
};
</script>
<style lang="less" scoped>
.pageIndex {
  background: #fff;
  font-size: 24px;
  .upgrade {
    position: fixed;
    z-index: 999;
    font-size: 130px;
    bottom: 50px;
    right: 50px;
    color: #cccccc;
    border-radius: 80px;
  }
}
.by-gry {
  width: 100%;
  font-size: 24px;
  position: absolute;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  top: 0;
  z-index: 999;
  color: #fff;
  .clo {
    text-align: center;
  }
  .ing {
    margin-top: 20%;
    background-image: url(../assets/image/hongbao.png);
    background-repeat: round;
    height: 846px;

    text-align: center;
    .div0 {
      height: 330px;
      padding-top: 480px;
    }
    .div1 {
      font-size: 36px;
    }
    .div2 {
      font-size: 100px;
      color: #fffc00;
    }
    .div3 {
      font-size: 36px;
      color: #b70000;
      margin-top: 20px;
    }
  }
}
</style>